module.exports = __webpack_public_path__ + "fonts/Manrope-700-vietnamese22_c4999d3.woff2";